"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ApiSubClient_1 = require("../../common/client/ApiSubClient");
const LinkEntity_1 = require("../../common/model/LinkEntity");
const ThemeConverter_1 = require("../model/theme/ThemeConverter");
const ProviderConverter_1 = require("../model/provider/ProviderConverter");
class ApiAlignmentsClient extends ApiSubClient_1.ApiSubClient {
    getThemesByIds(ids = []) {
        const getThemesLink = new LinkEntity_1.Link(this.getLinkOrThrow('getThemesByIds'));
        return this.axios
            .get(getThemesLink.getTemplatedLink({ id: ids }))
            .then((response) => {
            const themes = response.data._embedded.themes.map((bookEntity) => ThemeConverter_1.ThemeConverter.convert(bookEntity));
            return Promise.resolve(themes);
        });
    }
    getThemesByProvider(provider) {
        const getThemesLink = new LinkEntity_1.Link(this.getLinkOrThrow('getThemesByProvider'));
        return this.axios
            .get(getThemesLink.getTemplatedLink({ provider }))
            .then((response) => {
            const themes = response.data._embedded.themes.map((bookEntity) => ThemeConverter_1.ThemeConverter.convert(bookEntity));
            return Promise.resolve(themes);
        });
    }
    getThemeLogoSignedUploadLink(filename, contentType) {
        const link = this.getLinkOrThrow('createThemeLogoSignedUploadLink').href;
        return this.axios
            .post(link, {
            filename,
            contentType,
        })
            .then((it) => {
            return it.headers.location;
        });
    }
    updateTheme(theme, provider, title, type, logoFilename) {
        const updateThemeLink = theme.links?.updateTheme?.getOriginalLink();
        if (!updateThemeLink) {
            throw Error('Not authorized to update theme');
        }
        return this.axios
            .patch(updateThemeLink, {
            provider,
            title,
            type,
            logoFilename,
        })
            .then(() => Promise.resolve());
    }
    getAllProviders() {
        const getProvidersLink = new LinkEntity_1.Link(this.getLinkOrThrow('getAllProviders'));
        return this.axios
            .get(getProvidersLink.getOriginalLink())
            .then((response) => {
            const providers = response.data._embedded.providers.map((providerEntity) => ProviderConverter_1.ProviderConverter.convert(providerEntity));
            return Promise.resolve(providers);
        });
    }
    getThemeByProviderAndId(provider, id) {
        const link = new LinkEntity_1.Link(this.getLinkOrThrow('getThemesByProviderAndId'));
        return this.axios
            .get(link.getTemplatedLink({ provider, id }))
            .then((response) => Promise.resolve(ThemeConverter_1.ThemeConverter.convert(response.data)));
    }
    uploadThemeMapping(themeMapping) {
        const formData = new FormData();
        formData.append('file', themeMapping);
        const headers = {
            'Content-Type': 'multipart/form-data',
        };
        const uploadLink = new LinkEntity_1.Link(this.getLinkOrThrow('uploadProviderMapping'));
        return this.axios
            .patch(uploadLink.getTemplatedLink({}), formData, { headers })
            .then((response) => Promise.resolve({ message: response.data.message }))
            .catch((error) => Promise.reject({ message: error.message, reasons: error.reasons }));
    }
    deleteThemeById(theme) {
        const link = theme.links?.deleteThemeById?.getOriginalLink();
        if (!link) {
            throw Error('Not authorized to delete theme');
        }
        return this.axios.delete(link).then(() => Promise.resolve());
    }
    async updateProvider(provider, request) {
        const link = provider.links?.updateProvider?.getOriginalLink();
        if (!link) {
            throw Error('Not authorized to update provider');
        }
        const response = await this.axios.patch(link, request);
        return Promise.resolve(ProviderConverter_1.ProviderConverter.convert(response.data));
    }
    async renameProviderType(provider, request) {
        const link = provider.links?.renameProviderType?.getOriginalLink();
        if (!link) {
            throw Error('Not authorized to rename provider type');
        }
        const response = await this.axios.post(link, request);
        return Promise.resolve(ProviderConverter_1.ProviderConverter.convert(response.data));
    }
    async getProviderById(providerId) {
        const getProviderByIdLink = new LinkEntity_1.Link(this.getLinkOrThrow('getProviderById'));
        return this.axios
            .get(getProviderByIdLink.getTemplatedLink({ providerId }))
            .then((response) => {
            return Promise.resolve(ProviderConverter_1.ProviderConverter.convert(response.data));
        });
    }
    async createProvider(request) {
        const link = new LinkEntity_1.Link(this.getLinkOrThrow('createProvider'));
        const response = await this.axios.post(link.getOriginalLink(), request);
        return Promise.resolve(ProviderConverter_1.ProviderConverter.convert(response.data));
    }
}
exports.default = ApiAlignmentsClient;
//# sourceMappingURL=ApiAlignmentsClient.js.map